export const getSettings = state => state.reportTransportOrders.getIn(['list', 'settings'])
export const getData = state => state.reportTransportOrders.getIn(['list', 'data'])
export const getFetching = state => state.reportTransportOrders.getIn(['list', 'fetching'])
export const getError = state => state.reportTransportOrders.getIn(['list', 'error'])
